export default __webpack_public_path__ + "static/media/Sanathan_Textiles_updates.6c87cca3.jpg";